// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12TLJ","questions":"styles_questions__FHqjv","footer":"styles_footer__7E_n2"};